import { _pozicijeModulaCSVToArr } from "./ter-reactive-utils";


export const terDraftSelectKlimaKomoraAll = (draftel_arr) => {
  if (Array.isArray(draftel_arr)) {
    let klimakomora_arr = draftel_arr.filter(k => {
      if (k._draftelschemakey === 'terkk$klimakomora') {
        return true;
      }
      return false;
    });
    return klimakomora_arr;
  } else {
    return [];
  }
};


////// OLD++++++++++


export const terUtilsSelectKlimaKomoraBySubkey = (subkey, draftel_arr) => {
  let trazenaKlimaKomora = null;
  if (subkey !== '' && Array.isArray(draftel_arr)) {
    draftel_arr.forEach(k => {
      if (k.subkey === subkey) {
        trazenaKlimaKomora = k;
      }
    });
  } else {
    return false;
  }
  return trazenaKlimaKomora;
}

export const terUtilsSelectPozicijeModulaWhere = (broj, pozicijemodula) => {
  let pos = null;
  let pozicijeArr = _pozicijeModulaCSVToArr(pozicijemodula);
  if (Array.isArray(pozicijeArr)) {
    const index = broj - 1;
    if (pozicijeArr[index]) {
      pos = pozicijeArr[index];
      // console.log(pos);
    }
  }
  // console.log(pos);
  return pos;
};

export const terUtilsSelectModulBySubkey = (subkey, draftel_arr) => {
  let trazeniModul = null;
  if (subkey !== '' && Array.isArray(draftel_arr)) {
    draftel_arr.forEach(m => {
      if (m.subkey === subkey) {
        trazeniModul = m;
      }
    });
  } else {
    return false;
  }
  return trazeniModul; // TODO da li je bolje da returnujemo isto ili posebno null i false
}

export const terUtilsSelectModulByTrackerId = (trackerIdKey, trackerIdVal, draftel_arr) => {
  let trazeniModul = null;
  if (Array.isArray(draftel_arr)) {
    draftel_arr.forEach(m => {
      if (m[trackerIdKey] === trackerIdVal) {
        trazeniModul = m;
      }
    });
  } else {
    return false;
  }
  return trazeniModul; // TODO da li je bolje da returnujemo isto ili posebno null i false
}

export const terUtilsSelectModulWhere = (parent_subkey, draftel_arr) => {
  let trazeniNiz = draftel_arr.filter(m => {
    if (m.parent_subkey === parent_subkey) {
      // console.log('WHERE true');
      return true;
    }
    // console.log('WHERE false');
    return false;
  });
  return trazeniNiz;
}

export const terUtilsSelectPoluproizvodBySubkey = (subkey, draftel_arr) => {
  // console.log(subkey, draftel_arr);
  let trazeniPoluproizvod = null;
  if (subkey !== '' && Array.isArray(draftel_arr)) {
    draftel_arr.forEach(p => {
      if (p.subkey === subkey) {
        trazeniPoluproizvod = p;
      }
    });
  } else {
    return false;
  }
  return trazeniPoluproizvod;
}

export const terUtilsSelectPoluproizvodWhere = (parent_subkey, draftel_arr) => {
  // console.log(parent_subkey, draftel_arr);
  let trazeniNiz = draftel_arr.filter(p => {
    if (p.parent_subkey === parent_subkey) {
      // console.log('WHERE true');
      return true;
    }
    // console.log('WHERE false');
    return false;
  });
  return trazeniNiz;
}

